const bold3DExperience = (value: string) => value.replace('3D', '<b>3D</b>');

export default bold3DExperience;
